import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import ContactButtons from './../ContactButtons';
import errorIcon from '../../Images/errorIcon.svg';
import { getZoneFaultStatus } from './../../ZoneFaultSlice';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';

function ErrorPage(props) {

  const handleRetryClick = () => {
    props.showAppLoader();
    props.getZoneFaultStatus();
  };

  return (
    <div>
      <div className='zone-fault-error-page'>
        <div className='error-icon'>
          <Image src={errorIcon} className='icon' alt='Error Icon' />
        </div>
        <div className='error-title'>משהו השתבש ולא הצלחנו<br/> לבדוק את סטטוס התקלה</div>
        <div className='error-sub-title'>אפשר גם ליצור איתנו קשר</div>
        <div className='retry-button'>
          <BtnSubmit
            className='btn-submit'
            isBusiness={false}
            text={"ננסה שוב"}
            formid='error-page'
            isDisplayArrows={false}
            onclick={() => handleRetryClick()}
          />
        </div>
      </div>
        <ContactButtons />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    productsList: state.zoneFaultBlock.productsList,
    zoneFaultStatus: state.zoneFaultBlock.zoneFaultStatus,
  };
};

const mapDispatchToProps = {
  getZoneFaultStatus,
  showAppLoader,
  hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
